import { useState } from 'react'
import Navigation from './components/Navigation'
import DomicilisPage from './pages/DomicilisPage'
import RoutesPage from './pages/RoutesPage'
import MapPage from './pages/MapPage'
import SettingsPage from './pages/SettingsPage'
import RouteExecutionView from './pages/RouteExecutionView'

export default function App() {
  const [activeTab, setActiveTab] = useState('rutes')
  const [mapRutaId, setMapRutaId] = useState(null)
  const [execRutaId, setExecRutaId] = useState(null)

  function viewOnMap(rutaId) {
    setMapRutaId(rutaId)
  }

  return (
    <div style={S.app}>
      <main style={S.main}>
        {/*
          Totes les pàgines queden muntades (display:none per a les inactives).
          Això evita que el mapa Leaflet es destrueixi en canviar de pestanya.
        */}
        <div style={{ ...S.pag, display: activeTab === 'domicilis' ? 'flex' : 'none' }}>
          <DomicilisPage />
        </div>

        {/* Pestanya Rutes: mostra la llista, el mapa o la vista d'execució */}
        <div style={{ ...S.pag, display: activeTab === 'rutes' ? 'flex' : 'none' }}>
          <div style={{ ...S.pag, display: (mapRutaId || execRutaId) ? 'none' : 'flex' }}>
            <RoutesPage
              onViewOnMap={viewOnMap}
              onExecutar={id => setExecRutaId(id)}
            />
          </div>
          <div style={{ ...S.pag, display: (mapRutaId && !execRutaId) ? 'flex' : 'none' }}>
            <MapPage
              selectedRutaId={mapRutaId}
              onChangeRuta={setMapRutaId}
              onBack={() => setMapRutaId(null)}
              visible={!!mapRutaId && !execRutaId && activeTab === 'rutes'}
            />
          </div>
          <div style={{ ...S.pag, display: execRutaId ? 'flex' : 'none' }}>
            <RouteExecutionView
              rutaId={execRutaId}
              onBack={() => setExecRutaId(null)}
            />
          </div>
        </div>

        <div style={{ ...S.pag, display: activeTab === 'config' ? 'flex' : 'none' }}>
          <SettingsPage />
        </div>
      </main>
      <Navigation activeTab={activeTab} onTabChange={setActiveTab} />
    </div>
  )
}

const S = {
  app: {
    display: 'flex', flexDirection: 'column', height: '100dvh',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    backgroundColor: '#f9fafb',
  },
  main: { flex: 1, overflow: 'hidden', paddingBottom: 60 },
  pag:  { flexDirection: 'column', height: '100%', overflow: 'hidden' },
}
